import lib from "../js-lib/lib";
import toggler from "../js-lib/toggler";

const ImageVideoSlider = {
  // Set up Toggles

  scope: (elem) => {
    // lib.qsa(".image-video-slider .video-foreground").forEach((elem) => {
    // Select Video ID
    let id = elem.querySelector("[data-id]").dataset.id;

    console.log("id");

    // Define Video Playstate
    state.videos[id]["playstate"] = true;
    state.videos[id]["mutestate"] = true;
    state.videos[id]["fullscreenstate"] = false;

    // Handle Play Logic
    setTimeout(() => {
      ImageVideoSlider.playLogic(id, elem);
    }, 200);

    setTimeout(() => {
      ImageVideoSlider.muteLogic(id, elem);
    }, 300);

    // Handle First Play Button Click
    // elem.addEventListener("click", () => {
    //   if (elem.classList.contains("is-active-video")) {
    //     return;
    //   }

    //   elem.classList.add("is-active-video");
    //   ImageVideoSlider.openLogic(id, elem);
    // });

    // Handle Fullscreen Button Click
    elem.querySelectorAll(".faded-overlay, .faded-close").forEach((item) => {
      item.addEventListener("click", () => {
        state.videos[id].fullscreenstate = false;
        ImageVideoSlider.fullscreenLogic(id, elem);
      });
    });
    // Handle Fullscreen Button Click
    elem.querySelector(".ico-fullscreen").addEventListener("click", () => {
      state.videos[id].fullscreenstate == false
        ? (state.videos[id].fullscreenstate = true)
        : (state.videos[id].fullscreenstate = false);

      ImageVideoSlider.fullscreenLogic(id, elem);
    });

    // Handle Play Button Click
    elem.querySelector(".play-pause-video-9").addEventListener("click", () => {
      state.videos[id].playstate == false
        ? (state.videos[id].playstate = true)
        : (state.videos[id].playstate = false);

      ImageVideoSlider.playLogic(id, elem);
    });

    // handle Mute Button Click
    elem.querySelector(".mute-unmute-video-9").addEventListener("click", () => {
      state.videos[id].mutestate == true
        ? (state.videos[id].mutestate = false)
        : (state.videos[id].mutestate = true);

      ImageVideoSlider.muteLogic(id, elem);
    });
    // });
  },
  playLogic: (id, elem) => {
    elem.dataset.playstate = state.videos[id].playstate;
    state.videos[id].playstate == true
      ? state.videos[id].play()
      : state.videos[id].pause();
  },
  fullscreenLogic: (id, elem) => {
    elem.dataset.fullscreenstate = state.videos[id].fullscreenstate;
    state.videos[id].fullscreenstate == true
      ? document.querySelector("body").classList.add("fullscreen-video")
      : document.querySelector("body").classList.remove("fullscreen-video");
  },
  muteLogic: (id, elem) => {
    elem.dataset.mutestate = state.videos[id].mutestate;
    state.videos[id].muted = state.videos[id].mutestate == true ? true : false;
  },
  openLogic: (id, elem) => {
    state.videos[id].playstate = true;
    state.videos[id].mutestate = true;

    ImageVideoSlider.playLogic(id, elem);
    ImageVideoSlider.muteLogic(id, elem);
  },
  render: (state) => {},
};

export { ImageVideoSlider as default };
